import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface StepFooterProps {
  onSubmit?: () => void;
  isLoading?: boolean;
  currentStep?: number;
}

export const StepFooter = ({ onSubmit, currentStep, isLoading }: StepFooterProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "bg-background sticky bottom-0 flex w-full gap-4 border-t border-[#D3D0CA] py-4  sm:flex-row sm:items-start sm:justify-between sm:gap-0 md:-mt-24 md:py-6",
        {
          "flex-col": currentStep !== 4,
          "flex-col-reverse items-center": currentStep === 4,
        },
      )}
    >
      {currentStep !== 2 ? (
        <div className="flex-grow py-2 text-sm font-[650] text-[#AC9CA0] sm:block md:py-0">
          {t("circle.circleCreation")}
        </div>
      ) : (
        <Link to="/donor-profile" search={{ page: "challenges" }}>
          <Button
            className="px-10 py-4 font-[350] no-underline hover:bg-[#22222A] hover:text-white sm:min-w-[180px] sm:max-w-[230px]"
            // onClick={resetForm}
            variant="underline"
          >
            {t("challenge.goToProfile")}
          </Button>
        </Link>
      )}
      <Button onClick={onSubmit} size="lg" disabled={isLoading} type="submit">
        {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
        {currentStep === 1 && t("challenge.next")}
        {currentStep === 2 && t("circle.makeYourDonation")}
      </Button>
    </div>
  );
};
